import { render, staticRenderFns } from "./FramePreview.vue?vue&type=template&id=5f4163f4&"
import script from "./FramePreview.vue?vue&type=script&lang=js&"
export * from "./FramePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports